@for (t of $transitions(); track t.id) {
  <unity-action-transition-shared [transition]="t" [disabled]="$disabled()" (doTransitionEvent)="onTransition($event)" />
}
